import React from "react";
import { Grid } from "@mui/material";

import GridListItem from "components/common/grid/GridListItem";
import { DEFAULT_DATE_FORMAT } from "static/date";
import formatDate from "utils/formatDate";
import { capitalizeFirstLetter } from "utils/string";

const InsuranceInformationItem = ({ insurance }) => {
  return (
    <Grid container columnSpacing={3}>
      <Grid item container columnSpacing={3} className="view-pdf__drawer-grid">
        <GridListItem
          title="INSURANCE NAME"
          subTitle={insurance?.name ?? "—"}
          size="3"
        />
        <GridListItem
          title="PATIENT ID NUMBER"
          subTitle={insurance?.patientId ?? "—"}
          size="3"
        />
        <GridListItem
          title="PATIENT GROUP NUMBER"
          subTitle={insurance?.patientGroup ?? "—"}
          size="3"
        />
        <GridListItem
          title="INSURANCE CODE"
          subTitle={insurance?.payor_id ?? "—"}
          size="3"
        />

        <GridListItem title="PLAN" subTitle={insurance?.plan ?? "—"} size="3" />

        <GridListItem
          title="PATIENT RELATION"
          subTitle={insurance?.patientRelation ?? "—"}
          size="3"
        />

        <GridListItem
          title="EFFECTIVE DATE"
          subTitle={
            insurance?.effectiveDate
              ? formatDate(insurance?.effectiveDate, DEFAULT_DATE_FORMAT)
              : "—"
          }
          size="3"
        />
      </Grid>

      <Grid item container columnSpacing={3} className="view-pdf__drawer-grid">
        <GridListItem
          title="AUTHORIZATION CODE"
          subTitle={insurance?.authorization_code || "—"}
          size="3"
        />
        <GridListItem
          title="TREATMENT START"
          subTitle={
            insurance?.treatment_start
              ? formatDate(insurance?.treatment_start, DEFAULT_DATE_FORMAT)
              : "—"
          }
          size="3"
        />
        <GridListItem
          title="TREATMENT END"
          subTitle={
            insurance?.treatment_end
              ? formatDate(insurance?.treatment_end, DEFAULT_DATE_FORMAT)
              : "—"
          }
          size="3"
        />
      </Grid>

      <Grid item>
        <div className="patient-form__info--header">Insured Details:</div>
      </Grid>
      <Grid item container columnSpacing={3} className="view-pdf__drawer-grid">
        <GridListItem
          title="FIRST NAME"
          subTitle={insurance?.insured?.first_name ?? "—"}
          size="3"
        />
        <GridListItem
          title="LAST NAME"
          subTitle={insurance?.insured?.last_name ?? "—"}
          size="3"
        />
        <GridListItem
          title="GENDER"
          subTitle={
            insurance?.insured?.gender
              ? capitalizeFirstLetter(insurance?.insured?.gender)
              : "—"
          }
          size="3"
        />
        <GridListItem
          title="DOB"
          subTitle={
            insurance?.insured?.dob
              ? formatDate(insurance?.insured?.dob, DEFAULT_DATE_FORMAT)
              : "—"
          }
          size="3"
        />

        <GridListItem
          title="STREET"
          subTitle={insurance?.insured?.street ?? "—"}
          size="3"
        />
        <GridListItem
          title="CITY"
          subTitle={insurance?.insured?.city ?? "—"}
          size="3"
        />
        <GridListItem
          title="STATE"
          subTitle={insurance?.insured?.state ?? "—"}
          size="3"
        />
        <GridListItem
          title="ZIP"
          subTitle={insurance?.insured?.zip ?? "—"}
          size="3"
        />
      </Grid>
    </Grid>
  );
};

export default InsuranceInformationItem;
